<script>
import {isArray} from 'lodash'
import CardNewsItem from './CardNewsItem'

export default {
  name: 'CardNewsItemPagamento',
  components: {CardNewsItem},
  props: {
    calculo: {
      type: Object
    },
    preretiradas: {}
  },
  computed: {
    somaPagamentos () {
      if (!isArray(this.preretiradas) || this.preretiradas.length === 0) return 0
      let totalPago = 0
      this.preretiradas.forEach((e) => {
        if (parseInt(e.status) === 1) {
          totalPago = Number(totalPago) + Number(e.valor)
        }
      })
      return totalPago
    }
  }
}
</script>

<template>
  <card-news-item title="Pagamento">
    <u-fake-loader v-if="!calculo" width="100%" class="m-t"></u-fake-loader>
    <div v-else class="row m-t">
      <div class="col-xs-12" v-if="!preretiradas">
        <div>Inicie primeiro a pré-retirada para realizar a análise do pagamento.</div>
      </div>
      <div class="col-xs-12" v-else>
        <div v-if="somaPagamentos > 0">
          <div class="row" v-for="preretirada in preretiradas" v-if="preretirada.status === 1">
            <div class="col-xs-6">{{moment(preretirada.dataPagamento.date).format('L')}}</div>
            <div class="col-xs-6 text-right font-bold">R$ {{preretirada.valor|moeda}}</div>
          </div>
          <div class="row">
            <div class="col-xs-12 m-t-n m-b-n">
              <hr class="divider"/>
            </div>
            <div class="col-xs-12 text-right">
              Total pago: <span class="m-l-xs font-bold text-success">R$ {{somaPagamentos|moeda}}</span>
            </div>
            <div class="col-xs-12 text-right">Custo <small>({{calculo.base.diarias}} diárias)</small>: <span
              class="m-l-xs font-bold text-primary">R$ {{calculo.base.custoAtualizado|moeda}}</span></div>
            <div class="col-xs-12 text-right">
              Saldo Devedor: <span class="m-l-xs font-bold" :class="calculo.base.saldoDevedor > 0 ? 'text-danger' : ''">R$ {{calculo.base.saldoDevedor|moeda}}</span>
            </div>
          </div>
        </div>
        <div v-else>
          Nenhum pagamento reconhecido. Execute a consulta de pagamento por referência e defina a pré-retirada como paga.
        </div>
      </div>
    </div>
  </card-news-item>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// CardNewsItemPagamento.vue?34284818